import {
  EditableSnapQuote,
  EditSnapQuoteInput,
} from '@snap-types/actions/edit-snap-quote';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectQuery } from '@ui/store/api-builder/inject-query';

export const [editSnapQuote, useEditSnapQuoteQuery] = injectQuery<
  EditSnapQuoteInput,
  EditableSnapQuote
>(`${QUOTE_BUILDER_SLICE_NAME}/editSnapQuote`, ({ siteCode, quoteUuid }) => ({
  url: buildSnapQuoteUrl(siteCode, quoteUuid, 'edit'),
}));
